import { z } from 'zod';

const schema = z.object({
  id: z.string().nullish(),
  fileName: z.string().nullish(),
  mimeType: z.string().nullish(),
  bucketLocation: z.string().nullish(),
  data: z.any().nullish(),
});

export const fileValidation = z.array(schema);
